import UploadLoading, { UploadLoadingProps } from './UploadLoading.component';

export type UploadLoadingType = UploadLoadingProps;

export default UploadLoading;
